module.exports = __webpack_public_path__ + "img/the-netherlands-pneumonia-male.719ba774.png";